import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(theme => ({
  container: {
    alignItems: "center",
    paddingTop: 32,
  },
  name: {
    borderLeft: `2px solid ${colors.grayMedLight}`,
    paddingLeft: 24,
    paddingTop: 0,
    paddingBottom: 0,
    marginLeft: 20,
    marginBottom: 0,
  },
}));

export default useStyles;
